import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Plus, History, MapPin } from 'lucide-react';

const Dashboard = ({ inspectionHistory, setCurrentInspection, setInspectionHistory }) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="bg-blue-50 p-6 rounded-lg">
        <h2 className="text-2xl font-bold text-blue-900 mb-4 flex items-center">
          <FileText className="mr-2" />
          4LEAF HomeInspect Dashboard
        </h2>
        <p className="text-blue-700">Professional Rental Property Inspections</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <button
          onClick={() => navigate('/new')}
          className="bg-green-600 text-white p-6 rounded-lg hover:bg-green-700 transition-colors flex flex-col items-center"
        >
          <Plus className="w-8 h-8 mb-2" />
          <span className="text-lg font-semibold">New Inspection</span>
        </button>

        <button
          onClick={() => navigate('/inspection')}
          className="bg-blue-600 text-white p-6 rounded-lg hover:bg-blue-700 transition-colors flex flex-col items-center"
        >
          <History className="w-8 h-8 mb-2" />
          <span className="text-lg font-semibold">Continue Inspection</span>
        </button>

        <button
          onClick={() => alert('Property management coming soon!')}
          className="bg-purple-600 text-white p-6 rounded-lg hover:bg-purple-700 transition-colors flex flex-col items-center"
        >
          <MapPin className="w-8 h-8 mb-2" />
          <span className="text-lg font-semibold">Properties</span>
        </button>
      </div>

      <div className="bg-white p-6 rounded-lg border shadow-sm">
        <h3 className="text-lg font-semibold mb-4">Recent Inspections</h3>
        {inspectionHistory.length === 0 ? (
          <p className="text-gray-500">No inspections yet. Click "New Inspection" to get started.</p>
        ) : (
          inspectionHistory.slice(-5).map(inspection => (
            <div key={inspection.id} className="flex justify-between items-center py-2 border-b last:border-0">
              <div>
                <div className="font-medium">{inspection.property.streetName} {inspection.property.streetNumber}</div>
                <div className="text-sm text-gray-600">
                  {inspection.date} - {inspection.formType === 'health_safety' ? 'Health & Safety Code' : 'IPMC'}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Dashboard;
